export default {"src":"/_next/static/media/sons_logo_wht.a12ed29b.svg","height":80,"width":260,"blurWidth":0,"blurHeight":0};